// src/components/icons/CloseIcon.js
/* ------------------------------------------------------------------ */
/* CloseIcon – “X” used to dismiss dialogs / menus                     */
/* ------------------------------------------------------------------ */
/**
 * @param {object} props  Regular SVG props (className, onClick, …)
 * @returns {JSX.Element}
 */
export const CloseIcon = (props) => (
  <svg viewBox="0 0 24 24" className="h-8 w-8 fill-tertiary" {...props}>
    <path
      d="M6 6l12 12M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
